import React from 'react';
import ChipMui from '@mui/material/Chip';
import BoxMui from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { createStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

const Box = styled(BoxMui)(({ theme }) => ({
    '&.MuiBox-root': {
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        position: 'relative',
        margin: `${theme.spacing(3.75)} 0px`,
    },
}));

/** Default chip-only wrapper styles; fixed px avoids withStyles theme issues in renderToStaticMarkup */
const CHIP_ONLY_WRAPPER_DEFAULTS = {
    display: 'flex',
    marginTop: 16,
    marginBottom: 16,
    justifyContent: 'center',
};

const styles = () =>
    createStyles({
        chipContainer: {
            position: 'absolute',
            top: '-9px',
            left: '10px',
        },
        customChip: {
            fontSize: '10px',
            height: '19px',
        },
        label: {
            padding: '0px 8px',
        },
    });

/**
 * OR/AND relationship indicator between grouped summary blocks.
 *
 * @param {Object} props
 * @param {string} props.label - Chip text (e.g. "OR", "AND")
 * @param {boolean} [props.hideLine=false] - When true, chip-only wrapper (no horizontal rule). When false, line + absolute chip.
 * @param {Object} [props.style] - Merged onto the active wrapper (ChipOnlyBox or line Box). Call-site values win (e.g. left, justifyContent, margin).
 * @param {Object} props.classes - Injected by withStyles
 * @returns {React.ReactElement}
 */
const LogicalDivider = props => {
    const { label, hideLine = false, style, classes } = props;
    const chip = (
        <ChipMui label={label} classes={{ root: classes.customChip, label: classes.label }} />
    );

    if (hideLine) {
        return <BoxMui style={{ ...CHIP_ONLY_WRAPPER_DEFAULTS, ...style }}>{chip}</BoxMui>;
    }

    return (
        <Box style={style}>
            <div className={classes.chipContainer}>{chip}</div>
        </Box>
    );
};

export default withStyles(styles)(LogicalDivider);
